var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'base-textinput-container', 
    { disabled: _vm.disabled },
    ..._vm.styles
  ]},[_c('input',_vm._g(_vm._b({ref:"inputElement",attrs:{"type":"url","placeholder":_vm.placeholder,"maxlength":_vm.maxLength,"disabled":_vm.disabled},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.textInputListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }